import React, { useState } from 'react';

interface Props {
  onClose: () => void;
  onUpload: (file: File) => Promise<void>;
  uploading: boolean;
}

const UploadModal: React.FC<Props> = ({ onClose, onUpload, uploading }) => {
  const [file, setFile] = useState<File | null>(null);

  function handleFiles(files: FileList | null) {
    if (files && files[0]) {
      setFile(files[0]);
    }
  }

  async function handleUpload() {
    if (file) {
      await onUpload(file);
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center"
      onDragOver={e => e.preventDefault()}
      onDrop={e => {
        e.preventDefault();
        handleFiles(e.dataTransfer.files);
      }}
    >
      <div className="bg-white p-4 w-96">
        <h3 className="text-lg font-bold mb-2">Загрузка файла</h3>
        <div
          className="border-2 border-dashed border-gray-400 p-5 text-center mb-4 cursor-pointer"
          onClick={() => document.getElementById('fileInput')?.click()}
        >
          {file ? file.name : 'Перетащите файл сюда или нажмите для выбора'}
        </div>
        <input
          id="fileInput"
          type="file"
          className="hidden"
          onChange={e => handleFiles(e.target.files)}
        />
        <div className="text-right space-x-2">
          <button
            className="px-2 py-1 bg-red-500 text-white rounded"
            onClick={onClose}
            disabled={uploading}
          >
            Отменить
          </button>
          <button
            className="px-2 py-1 bg-blue-500 text-white rounded disabled:opacity-50"
            onClick={handleUpload}
            disabled={!file || uploading}
          >
            Загрузить
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;
